// ── Create Project Modal (shared by sidebar + projects page) ──

import { api } from '../api.js';
import { openModal, closeModal, showToast, esc } from '../ui.js';
import { navigate } from '../router.js';
import { refreshProjectList } from './sidebar.js';

// Returns the modal's owner token (TPT647). Opened from the sidebar as well as the dashboard,
// so it also closes itself on navigation (closeOnNavigate) — no page teardown owns the sidebar's.
export function openCreateProjectModal() {
  const body = `
    <form id="create-project-form">
      <div class="form-group">
        <label class="form-label" for="project-name">Name *</label>
        <input class="form-input" id="project-name" name="name" required maxlength="255"
               placeholder="My Project">
      </div>
      <div class="form-group">
        <label class="form-label" for="project-desc">Description</label>
        <textarea class="form-textarea" id="project-desc" name="description"
                  placeholder="Optional description"></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-ghost" id="modal-cancel">Cancel</button>
        <button type="submit" class="btn btn-primary" id="create-project-btn">Create</button>
      </div>
    </form>`;

  return openModal('New Project', body, {
    closeOnNavigate: true,
    onMount(overlay) {
      overlay.querySelector('#modal-cancel').addEventListener('click', closeModal);
      overlay.querySelector('#create-project-form').addEventListener('submit', async (e) => {
        e.preventDefault();
        const name = overlay.querySelector('#project-name').value.trim();
        const description = overlay.querySelector('#project-desc').value.trim();
        if (!name) return;

        const btn = overlay.querySelector('#create-project-btn');
        btn.disabled = true;
        btn.textContent = 'Creating...';

        try {
          const result = await api.post('/projects', {
            name,
            description: description || undefined,
          });
          closeModal();
          showToast('Project created', 'success');
          refreshProjectList();
          navigate('/projects/' + result.project.id);
        } catch (err) {
          btn.disabled = false;
          btn.textContent = 'Create';
          showToast(err.message || 'Failed to create project', 'error');
        }
      });
    }
  });
}
